import V2Context from "contexts/V2Context";
import { useContext } from "react";

const useV2 = () => useContext(V2Context);

export default useV2;
